import "./EMillennium.module.css";
import Header from "@/reusable_sections/Header";
import EMillenniumRealOmnichannelManagement from "./sections/EMillenniumRealOmnichannelManagement";
import EcossistemaDeTabelas from "./sections/EcossistemaDeTabelas";
import TalkToEMillenniumSpecialist from "./sections/TalkToEMillenniumSpecialist";
import SalesBoost from "./sections/SalesBoost";
import CompetitiveDifferentiation from "./sections/CompetitiveDifferentiation";
import UserSegments from "./sections/UserSegments";
import RodapeInstitucional from "@/reusable_sections/Footer";
export default function EMillenniumPage() {
  return <div>
      <Header />
      <EMillenniumRealOmnichannelManagement />
      <EcossistemaDeTabelas />
      <CompetitiveDifferentiation />
      <UserSegments />
      <TalkToEMillenniumSpecialist />
      <SalesBoost />
      <RodapeInstitucional />
    </div>;
}